/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ERepairerCaseRequest = 'WaitingConfirm' | 'OnGoing' | 'All' | 'Pending' | 'Open' | 'Closed' | 'WaitingPayment';

export const ERepairerCaseRequest = {
    WaitingConfirm: 'WaitingConfirm' as ERepairerCaseRequest,
    OnGoing: 'OnGoing' as ERepairerCaseRequest,
    All: 'All' as ERepairerCaseRequest,
    Pending: 'Pending' as ERepairerCaseRequest,
    Open: 'Open' as ERepairerCaseRequest,
    Closed: 'Closed' as ERepairerCaseRequest,
    WaitingPayment: 'WaitingPayment' as ERepairerCaseRequest
};

